import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param productId
   * @param deviceType
   */
  public apiProductViewTrackPost(
    productId: string,
    deviceType: string = 'Desktop',
    observe: any = 'body'
  ): Observable<any> {
    if (productId === null || productId === undefined) {
      throw new Error('Required parameter productId was null or undefined.');
    }

    let headers = this.defaultHeaders;

    const body = {
      product_id: productId,
      device_type: deviceType,
    };

    return this.httpClient.request<any>('post', `${this.basePath}/api/product-view/track`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
    });
  }

  /**
   * @param trackingId
   */
  public apiProductViewUpdateEndPut(trackingId: string, observe: any = 'body'): Observable<any> {
    if (trackingId === null || trackingId === undefined) {
      throw new Error('Required parameter trackingId was null or undefined.');
    }

    let headers = this.defaultHeaders;
    const body = { tracking_id: trackingId };

    return this.httpClient.request<any>('put', `${this.basePath}/api/product-view/update-end`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
    });
  }

  /**
   * @param userId
   */
  public apiProductViewUserUserIdGet(
    userId: string,
    page: number = 1,
    pageSize: number = 10,
    observe: any = 'body'
  ): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error('Required parameter userId was null or undefined.');
    }

    // Khởi tạo query parameters
    let queryParams = `?page=${page}&pageSize=${pageSize}`;

    return this.httpClient.request<any>(
      'get',
      `${this.basePath}/api/product-view/user/${encodeURIComponent(String(userId))}${queryParams}`,
      {
        withCredentials: this.configuration.withCredentials,
        observe: observe,
      }
    );
  }

  public apiProductViewProductProductIdGet(
    productId: string,
    page: number = 1,
    pageSize: number = 10,
    observe: any = 'body'
  ): Observable<any> {
    if (productId === null || productId === undefined) {
      throw new Error('Required parameter productId was null or undefined.');
    }

    let queryParams = `?page=${page}&pageSize=${pageSize}`;

    return this.httpClient.request<any>(
      'get',
      `${this.basePath}/api/product-view/product/${encodeURIComponent(String(productId))}${queryParams}`,
      {
        withCredentials: this.configuration.withCredentials,
        observe: observe,
      }
    );
  }

  /**
   */
  public apiProductViewStatisticsGet(observe: any = 'body'): Observable<any> {
    return this.httpClient.request<any>('get', `${this.basePath}/api/product-view/statistics`, {
      withCredentials: this.configuration.withCredentials,
      observe: observe,
    });
  }

  public apiProductViewAllGet(
    filters: string = '',
    sorts: string = '',
    page: number = 1,
    pageSize: number = 10,
    observe: any = 'body'
  ): Observable<any> {
    let queryParams = `?page=${page}&pageSize=${pageSize}`;
    if (filters) queryParams += `&filters=${encodeURIComponent(filters)}`;
    if (sorts) queryParams += `&sorts=${encodeURIComponent(sorts)}`;

    return this.httpClient.request<any>('get', `${this.basePath}/api/product-view/all${queryParams}`, {
      withCredentials: this.configuration.withCredentials,
      observe: observe,
    });
  }

  public apiProductViewTopViewedGet(
    top: number = 10,
    fromDate: string = '',
    toDate: string = '',
    observe: any = 'body'
  ): Observable<any> {
    let queryParams = `?top=${top}`;
    if (fromDate) queryParams += `&from_date=${encodeURIComponent(fromDate)}`;
    if (toDate) queryParams += `&to_date=${encodeURIComponent(toDate)}`;

    return this.httpClient.request<any>('get', `${this.basePath}/api/product-view/top-viewed${queryParams}`, {
      withCredentials: this.configuration.withCredentials,
      observe: observe,
    });
  }
}
